<template>
	<div class="incenters">
		<div>
			<!--  -->
			<Commonbtn backgroundColor="#FFF" title="查看" opwidth="71px" top="-1px" :optional="seeOptional"
				fontSize="14px" @btnclick="see" :src="require('@/assets/icon/look.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="SeExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>

			<!--  -->
			<Commonbtn backgroundColor="#FFF" title="二次校验" opwidth="100px" top="-1px" :optional="verificationOptional"
				fontSize="14px" @btnclick="verification" :src="require('@/assets/icon/check.png')">
			</Commonbtn>
			<!--  -->
			<Commonbtn backgroundColor="#FFF" title="三次校验" opwidth="100px" top="-1px" :optional="verificationOptional"
				fontSize="14px" @btnclick="verification3" :src="require('@/assets/icon/check.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="四次校验" opwidth="100px" top="-1px" :optional="verificationOptional"
				fontSize="14px" @btnclick="verification4" :src="require('@/assets/icon/check.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="填写备注" fontSize="14px" @btnclick="editDesc"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="commontable" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="1000px" title="查看" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<span>抛送参数:</span>
				<div class="JsonCss" v-html="DetailsList">
				</div>
				<span>反馈参数:</span>
				<div class="JsonCss" v-html="GetText">
				</div>
				<span>信息:</span>
				<div class="JsonCss">
					{{ SynMessage }}
				</div>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该菜单吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用该菜单吗？</span>
		</Dialog>


		<DialogFrom width="800px" title="填写备注" :dialogVisible="dialogVisibleDesc" @cancel="cancelDesc"
			@dialogOK="dialogOKDesc">
			<div class="InforDialog">
				<div class="textarea">
					<el-input type="textarea" placeholder="请输入内容" v-model="editDescContent" show-word-limit />
				</div>
			</div>
		</DialogFrom>

	</div>
</template>
<script>
	import Commondropdownlist from '../../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../../components/common-table.vue'
	import Commonbtn from '../../../../../components/common-btn.vue'
	import Pagination from '../../../../../components/pagination.vue'
	import DialogFrom from '../../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../../components/dialog.vue'
	import {
		Check2InvoiceEdit,
		Check2InvoiceInvoice,
		SetInvoiceRemark,
		Check3InvoiceInvoice,
		Check4InvoiceInvoice
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				editDescContent: '',
				dialogVisibleDesc: false,
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				rightboo: false,
				dwonleft: false,
				rowboo: false,
				seeOptional: false,
				verificationOptional: false,
				ptype: '',
				id: null,
				arrid: [],
				DetailsList: [],
				GetText: [],
				SynMessage: "",
				fromdataadd: [],
				fromdataedit: [],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50
					},
					{
						prop: 'StatusName',
						label: '状态',
						columnwidth: 80
					},
					{
						prop: 'InvoiceNo',
						label: '发票号',
						columnwidth: 100
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 80
					},
					{
						prop: 'CheckTimeCount',
						label: '校验次数',
						columnwidth: 80
					},
					{
						prop: 'CusName',
						label: '客户名称',
						columnwidth: 280
					},
					{
						prop: 'CreateTime',
						label: '校验时间',
						columnwidth: 200
					},
					{
						prop: 'SynMessage',
						label: '信息',
						columnwidth: 130
					},
					{
						prop: 'Remark',
						label: '备注'
					},
					{
						prop: 'Updater',
						label: '备注人'
					},
					{
						prop: 'UpdateTime',
						label: '备注日期'
					}
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus.map((item, index) => {
					if (item.NodeID == 31) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 46) {
								this.qus = items.Nodes
							}
						})
					}
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						}
					})
				}
			},
			SeExport() {
				this.$emit("SeExport")
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			verification() {
				if (this.arrid.length <= 0) {
					this.$message({
						type: 'warning',
						message: "请选择需要校验的数据"
					})
					return
				}
				this.check2InvoiceInvoice()
			},
			// 二次校验
			async check2InvoiceInvoice() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let idsArr = []
				this.arrid.map((item, index) => {
					idsArr.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await Check2InvoiceInvoice({
					iDs: idsArr
				})
				if (code == 0) {
					this.arrid = [];
					this.$message({
						type: 'success',
						message: message
					})
					this.$nextTick(() => {
						this.$refs.commontable.$refs.fileTableSelect.clearSelection();
					})
					this.$parent.check2InvoiceList()
					loading.close();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
					loading.close();
				}
			},
			verification3() {
				if (this.arrid.length <= 0) {
					this.$message({
						type: 'warning',
						message: "请选择需要校验的数据"
					})
					return
				}
				this.check3InvoiceInvoice()
			},
			// 三次校验
			async check3InvoiceInvoice() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let idsArr = []
				this.arrid.map((item, index) => {
					idsArr.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await Check3InvoiceInvoice({
					iDs: idsArr
				})
				if (code == 0) {
					this.arrid = [];
					this.$message({
						type: 'success',
						message: message
					})
					this.$nextTick(() => {
						this.$refs.commontable.$refs.fileTableSelect.clearSelection();
					})
					this.$parent.check2InvoiceList()
					loading.close();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
					loading.close();
				}
			},
			verification4() {
				if (this.arrid.length <= 0) {
					this.$message({
						type: 'warning',
						message: "请选择需要校验的数据"
					})
					return
				}
				this.check4InvoiceInvoice()
			},
			// 四次校验
			async check4InvoiceInvoice() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let idsArr = []
				this.arrid.map((item, index) => {
					idsArr.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await Check4InvoiceInvoice({
					iDs: idsArr
				})
				if (code == 0) {
					this.arrid = [];
					this.$message({
						type: 'success',
						message: message
					})
					this.$nextTick(() => {
						this.$refs.commontable.$refs.fileTableSelect.clearSelection();
					})
					this.$parent.check2InvoiceList()
					loading.close();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
					loading.close();
				}
			},
			//查看
			async cvheck2InvoiceEdit() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					code,
					data,
					message
				} = await Check2InvoiceEdit({
					id: this.id
				})
				if (code == 0) {
					this.dialogVisibles = true
					this.DetailsList = `<pre>${JSON.stringify(JSON.parse(data.data.PutText), null, 4)}</pre>`
					this.GetText = `<pre>${JSON.stringify(JSON.parse(data.data.GetText), null, 4)}</pre>`
					this.SynMessage = data.data.SynMessage
					this.rowboo = false
					loading.close();
				} else {
					this.$message({
						type: 'error',
						message: message
					})
					loading.close();
				}
			},
			see() {
				if (this.rowboo == true) {
					this.cvheck2InvoiceEdit()
					return
				}
				this.$message({
					type: 'error',
					message: '请先选中要查看的数据'
				})
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			onRowClick(val) {
				this.rowboo = true
				this.id = val.ID
			},
			handleSelectionChange(val) {
				this.arrid = val
				console.log(this.arrid);
			},
			update() {
				this.dialogVisiblesedit = true
			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.dialogVisiblesedit = false
			},
			del() {
				this.dialogVisibledel = true
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.dialogVisibledel = false
			},
			deactivate() {
				this.dialogVisibledeactivate = true
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.dialogVisibledeactivate = false
			},
			editDesc() {
				if (!this.arrid.length) {
					this.$message({
						type: 'error',
						message: '请先选中要查看的数据'
					})
					return;
				}
				this.dialogVisibleDesc = true
			},
			cancelDesc() {
				this.dialogVisibleDesc = false
			},
			async dialogOKDesc() {
				if (!this.editDescContent) {
					this.$message({
						type: 'error',
						message: '请先填写备注'
					})
					return;
				}
				let {
					code,
					data,
					message
				} = await SetInvoiceRemark({
					iDs: this.arrid.map(item => item.ID),
					remark: this.editDescContent,
				})
				if (code == 0) {
					this.editDescContent = '';
					this.dialogVisibleDesc = false;
					this.$refs.commontable.$refs.fileTableSelect.clearSelection();
					this.$parent.check2InvoiceList()
					this.$message({
						type: 'success',
						message: '提交成功'
					})
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.JsonCss {
		border: 2px solid rgb(0 38 109);
		width: 961px;
		border-radius: 3px;
		max-height: 250px;
		overflow: scroll;
		font-size: 15px;
	}

	/deep/.el-textarea__inner {
		width: 100%;
	}

	// .InforDialog {
	// 	max-height: 632px;
	// 	overflow-y: scroll;
	// }

	// .textarea {
	// 	margin-top: 16px;
	// }
</style>